export default __webpack_public_path__ + "static/media/brave_logo_2color_reversed.7095abf8.svg";